import * as Sentry from '@sentry/browser';
import {
  makeFetchTransport,
  makeMultiplexedTransport,
  MULTIPLEXED_TRANSPORT_EXTRA_KEY,
} from '@sentry/browser';
import { browserTracingIntegration, moduleMetadataIntegration } from '@sentry/vue';
import BUILD_VERSION from './BuildVersion';

if (process.env.NODE_ENV === 'production') {
  /** @see Taken from https://docs.sentry.io/platforms/javascript/best-practices/micro-frontends/ */
  const withMicroFrontendSetup = (event) => {
    if (event?.exception?.values?.[0].stacktrace.frames) {
      const { frames } = event.exception.values[0].stacktrace;
      const routeTo = frames
        .filter(
          (frame) => frame.module_metadata && frame.module_metadata.dsn,
        )
        .map((v) => v.module_metadata)
        .slice(-1);
      if (routeTo.length) {
        // eslint-disable-next-line no-param-reassign -- In line with officials docs
        event.extra = {
          ...event.extra,
          [MULTIPLEXED_TRANSPORT_EXTRA_KEY]: routeTo,
        };
      }
    }

    return event;
  };

  Sentry.init({
    async beforeSend(event) {
      const isSourceLocalWebpage = event.request.url.startsWith('file://');
      if (isSourceLocalWebpage) {
        return null;
      }
      const { default: { userId } } = await import('./VcomProvider');
      if (userId !== null) {
        /* eslint-disable-next-line no-param-reassign */
        event.user = { id: `${userId}` };
      }
      return withMicroFrontendSetup(event);
    },
    ignoreErrors: [
      /Network Error/i,
      /Request aborted/i,
      /Request failed with status code 400/i,
      /Request failed with status code 403/i,
      /Fetch Error/i,
      /Connection closed/i,
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    dsn: 'https://3148081529aa444ea5139109aa25e9fa@o154513.ingest.sentry.io/1211209',
    integrations: [browserTracingIntegration(), moduleMetadataIntegration()],
    transport: makeMultiplexedTransport(makeFetchTransport),
    tracesSampleRate: 0.01,
    release: BUILD_VERSION,
  });

  window.Sentry = Sentry;
}
